import React, { useEffect, useRef, useState } from "react";
import "../styles/PermissionFeedback.css";

export const PERMISSION_DENIED_EVENT = "app:permission-denied";

export function notifyPermissionDenied(message) {
  window.dispatchEvent(
    new CustomEvent(PERMISSION_DENIED_EVENT, {
      detail: {
        message:
          message || "You don't have permission to complete this action.",
      },
    }),
  );
}

export default function PermissionFeedback() {
  const [message, setMessage] = useState("");
  const timerRef = useRef(null);

  useEffect(() => {
    const showMessage = (event) => {
      window.clearTimeout(timerRef.current);
      setMessage(
        event.detail?.message ||
          "You don't have permission to complete this action.",
      );
      timerRef.current = window.setTimeout(() => setMessage(""), 5000);
    };

    window.addEventListener(PERMISSION_DENIED_EVENT, showMessage);
    return () => {
      window.removeEventListener(PERMISSION_DENIED_EVENT, showMessage);
      window.clearTimeout(timerRef.current);
    };
  }, []);

  if (!message) return null;

  return (
    <div className="permission-toast" role="alert" aria-live="assertive">
      <i className="fas fa-lock" aria-hidden="true" />
      <div>
        <strong>Permission required</strong>
        <span>{message}</span>
      </div>
      <button
        type="button"
        onClick={() => setMessage("")}
        aria-label="Dismiss permission message"
        data-no-standard-button="true"
      >
        <i className="fas fa-times" aria-hidden="true" />
      </button>
    </div>
  );
}
